import { BasketItem, BasketQuote, GenericErrorResponse, QuoteExtras } from '~/lib/types/basket-types';
import { BasketSections } from '~/lib/types/enums';
import BasketItemUpsells from './upsells';
import { BasketError } from './error';
import { P2GBox } from '@parcel2go/core-ui';

export const BasketItemExtras = ({
  itemId,
  items,
  errors,
  onEdit,
  isXs
}: {
  itemId: string;
  items: { name: string; item: BasketItem }[];
  errors: GenericErrorResponse | null;
  onEdit: (id: string, action: string) => void;
  isXs?: boolean;
}) => {
  const basketItem = items.find((i) => i.name === itemId);

  if (!basketItem) {
    return null;
  }

  const quote = basketItem.item.sections[BasketSections.QUOTE].payload as BasketQuote;
  const extras = basketItem.item.sections[BasketSections.EXTRAS].payload as QuoteExtras;

  return (
    <>
      <BasketItemUpsells
        currency={quote.currency}
        options={quote.availableExtras}
        extras={extras}
        itemId={basketItem.name}
      />
      <BasketError
        errors={errors?.issues?.filter((e) => e.itemRef === basketItem.name) ?? []}
        onResolve={(action) => onEdit(itemId, action)}
        wrapper={(x) => <P2GBox mt={isXs ? 2 : 3}>{x}</P2GBox>}
      />
    </>
  );
};
